import { useTranslation } from "react-i18next";
import { LegalScreen, Paragraph, Section } from "./legal-ui";

interface Props {
  isDesktop: boolean;
  onBack: () => void;
}

const SUPPORT_EMAIL = "gjelirefail@gmail.com";

export function PrivacyPolicyScreen({ isDesktop, onBack }: Props) {
  const { t } = useTranslation();
  return (
    <LegalScreen
      isDesktop={isDesktop}
      title={t("legal.privacy.title")}
      lastUpdated={t("legal.lastUpdatedValue")}
      onBack={onBack}
    >
      <Paragraph>{t("legal.privacy.intro")}</Paragraph>

      <Section title={t("legal.privacy.infoCollect")}>
        <Paragraph>{t("legal.privacy.infoCollectIntro")}</Paragraph>
        <ul style={listStyle}>
          <li>{t("legal.privacy.infoCollectEmail")}</li>
          <li>{t("legal.privacy.infoCollectUsername")}</li>
          <li>{t("legal.privacy.infoCollectExpenses")}</li>
        </ul>
        <Paragraph>{t("legal.privacy.infoCollectOutro")}</Paragraph>
      </Section>

      <Section title={t("legal.privacy.infoUse")}>
        <Paragraph>{t("legal.privacy.infoUseBody")}</Paragraph>
      </Section>

      <Section title={t("legal.privacy.storage")}>
        <Paragraph>{t("legal.privacy.storageBody")}</Paragraph>
      </Section>

      <Section title={t("legal.privacy.deletion")}>
        <Paragraph>{t("legal.privacy.deletionBody")}</Paragraph>
      </Section>

      <Section title={t("legal.privacy.retention")}>
        <Paragraph>{t("legal.privacy.retentionBody")}</Paragraph>
      </Section>

      <Section title={t("legal.privacy.children")}>
        <Paragraph>{t("legal.privacy.childrenBody")}</Paragraph>
      </Section>

      <Section title={t("legal.privacy.changes")}>
        <Paragraph>{t("legal.privacy.changesBody")}</Paragraph>
      </Section>

      <Section title={t("legal.privacy.contact")}>
        <Paragraph>
          {t("legal.privacy.contactBodyPrefix")}
          <a href={`mailto:${SUPPORT_EMAIL}`} style={linkStyle}>
            {SUPPORT_EMAIL}
          </a>
          .
        </Paragraph>
      </Section>
    </LegalScreen>
  );
}

const listStyle: React.CSSProperties = {
  margin: "0 0 12px 0",
  paddingLeft: 20,
  fontSize: 14,
  lineHeight: 1.7,
  color: "var(--ink-2)",
};

const linkStyle: React.CSSProperties = {
  color: "var(--ink)",
  textDecoration: "underline",
};
